import { render, staticRenderFns } from "./EditIncomeConf.vue?vue&type=template&id=7074b1fb&scoped=true&"
import script from "./EditIncomeConf.vue?vue&type=script&lang=js&"
export * from "./EditIncomeConf.vue?vue&type=script&lang=js&"
import style0 from "./EditIncomeConf.vue?vue&type=style&index=0&id=7074b1fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074b1fb",
  null
  
)

export default component.exports